var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaret587E85(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.47587 1.88363C-0.0532117 1.38761 0.297795 0.5 1.02302 0.5H7.15903C7.85853 0.5 8.22115 1.33448 7.74387 1.84585L4.8804 4.91386C4.57846 5.23736 4.07124 5.25429 3.74841 4.95163L0.47587 1.88363Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret587E85);
export default __webpack_public_path__ + "static/media/caret-587E85.f7ae43f158929fc21226dd60e02272f9.svg";
export { ForwardRef as ReactComponent };